export default {
  PAYMENT_RESOLUTION: 'PAYMENT_RESOLUTION',
  PAYMENT_CHANGE: 'PAYMENT_CHANGE',
  CHECKOUT: 'CHECKOUT',
};
